import React from 'react';
import MuiAutoComplete, { AutocompleteRenderInputParams } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { CircularProgress, Typography } from '@mui/material';
import { AutocompleteProps } from 'types/autocomplete';
import { get } from 'utils/helpers';

const Autocomplete: React.FC<AutocompleteProps> = ({
    options,
    value,
    loading,
    label,
    placeholder,
    error,
    helperText,
    matchKey,
    ...props
}) => {
    if (value && typeof value !== 'object' && typeof options?.[0] === 'object') {
        value = options.find((op) => get(op, matchKey || 'value', null) === value) || value || null;
    }

    return (
        <MuiAutoComplete
            value={value}
            options={options || []}
            aria-placeholder="Please select option"
            renderInput={(params: AutocompleteRenderInputParams) => (
                <TextField
                    {...params}
                    sx={{ input: { fontWeight: 600 } }}
                    placeholder={placeholder}
                    error={error}
                    helperText={helperText}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="warning" size={20} /> : null}
                                {params?.InputProps?.endAdornment}
                            </React.Fragment>
                        ),
                        startAdornment: (
                            <React.Fragment>{label && <Typography sx={{ color: 'black' }}>{label}:</Typography>}</React.Fragment>
                        ),
                    }}
                />
            )}
            {...props}
        />
    );
};

export default Autocomplete;
